/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "image": {
    "colors_default": "",
    "size_default": "aspect-default",
    "variant_default": "relative block object-cover"
  },
  "caption_colors_default": "text-fe-summer-red-600",
  "caption_size_horizontal": "text-fe-category-sm md:text-fe-category-lg",
  "caption_size_vertical": "text-fe-category-sm md:text-fe-category-lg group-[.bg]/box:mx-4",
  "caption_variant_horizontal": "break-words capitalize",
  "caption_variant_vertical": "break-words capitalize",
  "description_colors_default": "text-black",
  "description_size_horizontal": "text-fe-preamble-sm sm:container-col-sm-7:text-fe-preamble-lg sm:container-col-sm-7:mt-3",
  "description_size_vertical": "text-fe-preamble-sm container-col-lg-5:text-fe-preamble-sm container-col-lg-7:text-fe-preamble-sm sm:container-col-lg-5:text-fe-preamble-lg sm:container-col-lg-7:text-fe-preamble-lg sm:container-col-lg-4:mt-2 sm:container-col-lg-7:mt-3 mt-1",
  "description_variant_horizontal": "break-words",
  "description_variant_vertical": "break-words",
  "footer_colors_default": "",
  "footer_size_horizontal": "max-w-full",
  "footer_size_vertical": "max-w-full",
  "footer_variant_horizontal": "col-span-full overflow-hidden",
  "footer_variant_vertical": "overflow-hidden",
  "group_colors_default": "",
  "group_size_horizontal": "gap-0.5",
  "group_size_vertical": "gap-0.5",
  "group_variant_horizontal": "flex flex-col min-w-[0]",
  "group_variant_vertical": "flex flex-col min-w-[0]",
  "header_colors_default": "",
  "header_size_horizontal": "max-w-full",
  "header_size_vertical": "max-w-full",
  "header_variant_horizontal": "col-span-2 overflow-hidden",
  "header_variant_vertical": "overflow-hidden",
  "headline_colors_default": "text-black",
  "headline_size_horizontal": "text-fe-headline-sm sm:container-col-sm-4:text-fe-headline-md sm:container-col-lg-7:text-fe-headline-xl",
  "headline_size_vertical": "sm:container-col-lg-4:text-fe-headline-md sm:container-col-lg-5:text-fe-headline-lg sm:container-col-lg-8:text-fe-headline-2xl sm:container-col-lg-7:text-fe-headline-lg container-col-sm-7:text-fe-headline-lg text-fe-headline-sm sm:text-fe-headline-md group-[.bg]/box:mx-4 group-[.bg]/box:mb-4",
  "headline_variant_horizontal": "break-words",
  "headline_variant_vertical": "break-words",
  "colors_default": "",
  "size_horizontal": "w-full gap-3 grid-cols-2",
  "size_vertical": "w-full gap-3 auto-rows-min",
  "variant_horizontal": "grid container-inline",
  "variant_vertical": "grid container-inline",
  "card": {
    "headline_colors_default": "[&>span.underline]:before:bg-[url('/image/article-card-blob.svg')]",
    "headline_size_vertical": "text-fe-headline-md container-col-lg-7:md:text-fe-headline-xl [&>span.underline]:before:h-2.5 [&>span.underline]:before:w-[102%]",
    "headline_variant_vertical": "container-col-lg-4:md:before:hidden container-col-lg-7:md:before:block [&>span.underline]:no-underline [&>span.underline]:relative [&>span.underline]:inline-block [&>span.underline]:before:absolute [&>span.underline]:before:bg-no-repeat [&>span.underline]:before:-bottom-1.5",
    "size_vertical": "w-full gap-0 auto-rows-min",
    "extend": {
      "group_colors_default": "bg-fe-linen-100 md:bg-white",
      "group_size_vertical": "ml-6 md:ml-0 p-3 container-col-lg-7:md:p-9 md:w-[80%]",
      "group_variant_vertical": "relative -top-6 md:-top-9 md:left-9"
    }
  }
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "ContentArticleTeaserDefault");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;